// pl/channel.js
export const channel = {
  header: {
    title: "Kanały rezerwacji",
    subtitle: "Synchronizuj Booking.com, Expedia, Airbnb i wiele innych kanałów lub nimi zarządzaj.",
  },

  establishedConnections: "Nawiązane połączenia",

  common: {
    loading: "Wczytywanie...",
    configure: "Konfiguruj",
    close: "Zamknij",
    comingSoon: "Wkrótce",
  },

  alerts: {
    bullets: {
      choosePlan: "Wybierz plan i aktywuj Channel Manager.",
      completeProperty: "Uzupełnij konfigurację obiektu w panelu.",
    },
    title: "Wymagane działanie",
    planRequired:
      "Aby połączyć obiekt z kanałem OTA, konieczny jest aktywny plan.",
    missingPropertyChannel:
      "Aby połączyć się z kanałem OTA, należy najpierw uzupełnić konfigurację obiektu w Channel Managerze.",
  },

  modal: {
    channelHeader: "Połączenie z kanałem {channel}",
  },

  web: {
    cardTitle: "Rezerwacje bezpośrednie przez stronę",
    // NEW: description for the OTA-style card
    cardDescription:
      "Przyjmuj rezerwacje bezpośrednie ze swojej strony, bez prowizji OTA.",
    // NEW: button texts for card and table
    manageCta: "Zarządzaj",
    configureCta: "Konfiguruj",
    // NEW: label for the ID column of the direct bookings row
    directLinkLabel: "Link do rezerwacji bezpośredniej",

    linkShareMessage: "Dzień dobry 👋 Rezerwacji można dokonać, korzystając z tego linku:\n\n{link}",
    modalTitle: "Rezerwacje bezpośrednie przez stronę",
    description:
      "Włącz lub wyłącz opcje dostępne dla rezerwacji bezpośrednich na swojej stronie. Goście będą mogli rezerwować bezpośrednio, bez pośredników.",
    toggleAllDesktop: "Włącz/wyłącz wszystkie rezerwacje przez stronę",
    toggleAllMobile: "Włącz/wyłącz",
    table: {
      name: "Nazwa",
      available: "Dostępne do rezerwacji przez stronę",
    },
    capacity: "Pojemność",
    people: "osób",
    empty: "Nie znaleziono pozycji",

    // Link section
    linkTitle: "Link do rezerwacji bezpośrednich",
    linkHelp: "Udostępnij ten link, aby goście mogli rezerwować bezpośrednio",
    linkCopyTooltip: "Kopiuj link",
    linkShareWhatsappTooltip: "Udostępnij przez WhatsApp",
  },

  plan: {
    title: "Aktywuj plan, aby się połączyć",
    subtitle:
      "Wybierz plan dopasowany do swoich potrzeb i uruchom połączenie z Booking, Airbnb, Expedia i innymi kanałami.",
    hint: "Po wykupieniu subskrypcji prosimy tu wrócić; odblokujemy wtedy wszystkie kanały, z którymi można się połączyć.",
    cta: "Zmień plan",
  },

  toasts: {
    paymentTypeUpdated: "Metoda płatności została zaktualizowana",
    linkCopiedTitle: "Skopiowano!",
    linkCopiedBody: "Link został skopiowany",
    linkCopyErrorTitle: "Błąd",
    linkCopyErrorBody: "Wystąpił błąd podczas kopiowania linku",
    save: "Błąd podczas zapisywania konfiguracji",
    updateWebReservation: "Błąd podczas aktualizacji rezerwacji przez stronę",
    saved: "Konfiguracja została zapisana",
    updateWebReservationsGlobal:
      "Globalny stan rezerwacji bezpośrednich został zaktualizowany",
  },

  errors: {
    loadData: "Błąd podczas wczytywania danych. Spróbuj ponownie.",
    generateToken: "Błąd podczas generowania tokenu",
    connectChannel: "Błąd podczas łączenia z kanałem. Spróbuj ponownie.",
    updatePaymentType: "Błąd podczas aktualizacji metody płatności",
    save: "Błąd podczas zapisywania konfiguracji",
    updateWebReservation: "Błąd podczas aktualizacji rezerwacji przez stronę",
  },

  tabs: {
    reservations: "Status rezerwacji",
    payments: "Ceny i płatności",
    share: "Udostępnianie",
  },

  payments: {
    title: "W jaki sposób chcesz otrzymywać płatności za rezerwacje bezpośrednie?",
    onArrival: {
      label: "Płatność w obiekcie",
      desc: "Goście zapłacą bezpośrednio po przyjeździe",
    },
    online: {
      label: "Przedpłata online",
      desc: "Goście zapłacą w momencie dokonywania rezerwacji",
    },
  },

  discounts: {
    sectionTitle: "Skonfiguruj zniżkę dla rezerwacji bezpośrednich",
    toggle: "Zastosuj zniżkę do rezerwacji bezpośrednich",
    typeTitle: "Typ zniżki:",
    percentage: {
      label: "Zniżka procentowa",
      desc: "Zastosuj zniżkę procentową",
    },
    fixed: {
      label: "Zniżka kwotowa",
      desc: "Zastosuj zniżkę o stałej kwocie",
    },
    valueTitle: "Wartość zniżki:",
    placeholderPercentage: "Np. 10",
    placeholderFixed: "Np. 50,00",
    helpPercentage:
      "Wpisz wartość od 1 do 100 jako procent zniżki",
    helpFixed: "Wpisz stałą kwotę w euro, która zostanie odjęta od sumy",
    previewTitle: "Podgląd:",
    previewPercentage: "Do rezerwacji bezpośrednich zostanie zastosowana zniżka {value}%",
    previewFixed: "Do rezerwacji bezpośrednich zostanie zastosowana zniżka {value} €",
  },

  buttons: {
    saveChanges: "Zapisz zmiany",
  },
};
